'use strict';

require('prop-types');
var React = require('react');
var Typography = require('../../DesignSystem/DataDisplay/Typography/Typography.js');
var DialogTitle = require('../../DesignSystem/Feedback/Dialog/DialogTitle.js');
var withStyles = require('../../node_modules/@material-ui/core/esm/styles/withStyles.js');
var Dialog = require('../../node_modules/@material-ui/core/esm/Dialog/Dialog.js');
var DialogContent = require('../../node_modules/@material-ui/core/esm/DialogContent/DialogContent.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var styles = {
  dialogContent: {
    textAlign: 'center',
    marginTop: 24
  },
  alertImage: {
    marginBottom: 24,
    maxWidth: 250,
    maxHeight: 250
  }
};

function AlertDialog(_ref) {
  var classes = _ref.classes,
      open = _ref.open,
      onClose = _ref.onClose,
      imageSrc = _ref.imageSrc,
      alertMessage = _ref.alertMessage,
      captionMessage = _ref.captionMessage;
  return React__default["default"].createElement(Dialog["default"], {
    open: open,
    onClose: onClose,
    maxWidth: "sm",
    fullWidth: true
  }, React__default["default"].createElement(DialogTitle, {
    onClose: onClose
  }), React__default["default"].createElement(DialogContent["default"], {
    className: classes.dialogContent
  }, React__default["default"].createElement("img", {
    src: imageSrc,
    className: classes.alertImage
  }), React__default["default"].createElement(Typography, {
    variant: 'h6'
  }, alertMessage), React__default["default"].createElement(Typography, null, captionMessage)));
}

var AlertDialog$1 = withStyles(styles)(AlertDialog);

module.exports = AlertDialog$1;
